import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useComplaintHttp } from '@/core/api/complaints'
import { Complaint, ComplaintPayload } from '@/core/models/complaint'

export type ComplaintCollection = {
    data: Array<Complaint>,
    meta?: MetaPayload,
    links?: any
}

const state: ComplaintCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const complaintCollection: Module<ComplaintCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ComplaintCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ComplaintPayload) => {
                state.data.push(new Complaint(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useComplaintHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ComplaintCollection): ComplaintCollection => {
            return state
        }
    }
}